import extend from 'lodash/extend'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	loading: false,
	company: {},
	d4sign: {},
	clicksign: {},
}

const { actions, reducer } = createSlice({
	name: 'integrations',
	initialState,
	reducers: {
		getIntegration: (state) =>
			extend(state, {
				loading: true,
				company: {},
			}),
		getIntegrationSuccess: (state, { payload }) => {
			extend(state, {
				loading: false,
				company: payload,
			})
		},
		getIntegrationFailure: (state, { payload }) =>
			extend(state, {
				error: payload.error,
				loading: false,
			}),
		saveIntegration: (state) =>
			extend(state, {
				loading: true,
			}),
		saveIntegrationSuccess: (state, { payload }) =>
			extend(state, {
				loading: false,
				// Salvando dados do Clicksign, se estiverem no payload
				clicksign: payload.clicksign
					? { ...payload.clicksign }
					: state.clicksign,
			}),
		saveIntegrationFailure: (state, { payload }) =>
			extend(state, {
				error: payload.error,
				loading: false,
			}),
		getD4sign: (state) =>
			extend(state, {
				loading: true,
			}),
		getD4signSuccess: (state, { payload }) =>
			extend(state, {
				loading: false,
				d4sign: {
					...payload,
				},
				data: payload,
			}),
		getD4signFailure: (state, { payload }) =>
			extend(state, {
				error: payload.error,
				loading: false,
			}),
		getClicksign: (state) =>
			extend(state, {
				loading: true,
			}),
		getClicksignSuccess: (state, { payload }) =>
			extend(state, {
				loading: false,
				clicksign: {
					...payload,
				},
				data: payload,
			}),
		getClicksignFailure: (state, { payload }) =>
			extend(state, {
				error: payload.error,
				loading: false,
			}),
	},
})

export const {
	getIntegration,
	getIntegrationSuccess,
	getIntegrationFailure,
	saveIntegration,
	saveIntegrationSuccess,
	saveIntegrationFailure,
	getD4sign,
	getD4signSuccess,
	getD4signFailure,
	getClicksign,
	getClicksignSuccess,
	getClicksignFailure,
} = actions

export { default as integrationsSaga } from './sagas'

export default reducer
